module.exports = __webpack_public_path__ + "img/banner-intro-img.5e7da287.jpg";